<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR PASIEN RAWAT JALAN
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-5 mx-auto">
                <SelectInput
                            v-model="statusData"
                            id="status"
                            label="STATUS"
                        >
                            <option value="">=== PILIH STATUS ===</option>
                            <option value="all">Semua</option>
                            <option value="active">Aktif</option>
                            <option value="out">Keluar</option>
                            <option value="void">Void</option>
                </SelectInput>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglMasukData"
                    class="w-full grow mr-5"
                    id="tgl_masuk"
                    label="PILIH TANGGAL PERIKSA"
                />
            </div>
            <div class="w-full flex md:w-1/2 mx-auto">
                <button
                    @click.prevent="exportExcelAll()"
                    class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2"
                >
                    EXPORT EXCEL
                </button>
                <button
                    @click.prevent="getRekapPasienRajal()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500"
                            >{{ timerCount }} (10 Menit)</span
                        >
                    </p>
                </div>
                <div class="w-full grid grid-cols-2 gap-4">
                    <div v-for="rpj in rekapPasienRajalData" class="w-full bg-white rounded-md shadow p-3 mb-5">
                        <button
                            @click.prevent="exportExcel(rpj.kodePoli)"
                            class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2 mb-3"
                        >
                            EXPORT EXCEL
                        </button>
                        <div class="w-3/4 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3">
                            
                            <table class="w-full whitespace-nowrap">
                                <tr class="text-left font-bold bg-amber-100">
                                    <td class="py-2 px-3 text-center text-sm">Nama Poli</td>
                                    <td class="py-2 px-3 text-center text-sm">Total Pasien</td>
                                    <td class="py-2 px-3 text-center text-sm">Batal</td>
                                </tr>
                                <tr class="hover:bg-gray-100">
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{rpj.namaPoli}}</td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{rpj.totalPasien}}</td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{rpj.batal}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                        <table class="w-full whitespace-nowrap">
                            <thead>
                                <tr class="text-left font-bold bg-amber-100">
                                    <th class="py-2 px-3 text-center text-sm">
                                        No Antri
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Nama
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Status
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Jaminan
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Total Tarif RS
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No SEP
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        JML Bayar
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tgl Reg Keluar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="pasien in rpj.pasien"
                                    class="hover:bg-gray-100"
                                    :class="{
                                        'bg-red-500 text-white': getStatusAntrian(pasien) === 'Belum Dilayani' || 
                                                                    getStatusAntrian(pasien) === 'Tidak datang/batal' ||
                                                                    getStatusAntrian(pasien) === 'Selesai Tidak Datang/Batal' , 
                                        'bg-blue-500 text-white': pasien.fs_nm_tipe_jaminan === 'BPJS KETENAGAKERJAAN'
                                    }"
                                >
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ pasien.fn_no_urut }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ pasien.fs_nm_pasien }}
                                    </td>
                                    <td 
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ getStatusAntrian(pasien) }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ pasien.fs_nm_tipe_jaminan }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ Number(pasien.tarif_rs).toLocaleString("en-US") }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ pasien.fs_no_sep }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ Number(pasien.jml_bayar).toLocaleString("en-US") }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ pasien.fd_tgl_keluar }}
                                    </td>
                                </tr>
                                <tr class="bg-white hover:bg-gray-100 focus-within:bg-gray-100" v-if="rpj.pasien.length === 0">
                                    <td class="border-r border-t text-sm select-none cursor-pointer" colspan="8">
                                        Belum ada data pasien rawat jalan
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput
    },
    data() {
        return {
            tglMasukData: this.tglMasuk,
            statusData: this.status,
            rekapPasienRajalData: this.rekapPasienRajal,
            timerCount: 600
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getRekapPasienRajal(this.activeData);
                }
            },
            immediate: true,
        },
    },
    props: {
        tglMasuk: String,
        status: String,
        rekapPasienRajal: Object,
    },
    methods: {
        getRekapPasienRajal() {
            this.$inertia.get(
                "/admin/rekap_pasien_rajal/ajax",
                {
                    tglMasuk: this.tglMasukData,
                    status: this.statusData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 600;
                        this.rekapPasienRajalData = page.props.additional.rekapPasienRajal;
                    },
                }
            );
        },
        exportExcel(fsKdPoli){
            location.href = '/admin/rekap_pasien_rajal/export/excel?tglMasuk='+this.tglMasukData+'&status='+this.statusData+'&fsKdPoli='+fsKdPoli;
        },
        exportExcelAll(){
            location.href = '/admin/rekap_pasien_rajal/export/excelall?tglMasuk='+this.tglMasukData+'&status='+this.statusData;
        },
        getStatusAntrian(data){
            if (data.fs_jam_checkin == "00:00:00") {
                return "Belum Dilayani";
            }
            if (
                data.fs_jam_checkin != "00:00:00" &&
                data.fs_jam_masuk == "00:00:00"
            ) {
                return "TTV - " + data.fs_jam_checkin;
            }
            if (
                data.fs_jam_checkin != "00:00:00" &&
                data.fs_jam_masuk != "00:00:00" &&
                data.fs_jam_keluar == "00:00:00"
            ) {
                return "Sedang Dilayani";
            }
            if (
                data.fs_jam_checkin != "00:00:00" &&
                data.fs_jam_masuk != "00:00:00" &&
                data.fs_jam_keluar != "00:00:00"
            ) {
                if(data.fs_kd_selesai){
                    return "Selesai "+ data.ket_selesai;
                }else{
                    return "Selesai";
                }
            }

            if (data.fs_kd_selesai == 4) {
                return "Tidak datang/batal";
            }

        }
    },
    layout: LayoutAdminBig,
};
</script>
